import { color } from "chart.js/helpers";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* ✅ Success Icon */}
        <div style={styles.icon}>✅</div>

        {/* ✅ Title */}
        <h1 style={styles.title}>Thank You!</h1>
        <p style={styles.subtitle}>
          Technician Assigned Successfully
        </p>

        {/* ✅ Details Box */}
        <div style={styles.details} >
          <p style={{ color: "#000" }}>
            <strong style={{ color: "#000" }}>Booking ID:</strong>{" "}
            {location.state?.trackingId || "-"}
          </p>
          <p style={{ color: "#000" }}>
            <strong style={{ color: "#000" }}>Technician:</strong>{" "}
            {location.state?.technician || "-"}
          </p>
        </div>

        {/* ✅ Button */}
        <button style={styles.button} onClick={() => navigate("/")}>
          Go to Home
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    background: "linear-gradient(to right, #eef2ff, #f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "400px",
    width: "90%",
  },
  icon: {
    fontSize: "50px",
    marginBottom: "10px",
  },
  title: {
    color: "#16a34a",
    marginBottom: "10px",
  },
  subtitle: {
    color: "#4b5563",
    marginBottom: "20px",
  },
  details: {
    background: "#f1f5f9",
    padding: "15px",
    borderRadius: "10px",
    marginBottom: "20px",
    textAlign: "left",
  },
  button: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default ThankYou;